import React from 'react';
import { Col, Row, Table } from 'antd';

const column = [
  {
    title: 'Số lượng ngày lưu',
    dataIndex: 'dayStorage',
    key: 'dayStorage',
  },
  {
    title: 'Số lượng camera',
    dataIndex: 'numberCamera',
    key: 'numberCamera',
  },
];

const StorageReportSection = ({ data, storageCamera }) => {
  if (!data?.cameraStatisticStorage) {
    return null;
  }

  return (
    <div>
      <div className="section-title">THỐNG KÊ SỐ LƯỢNG LƯU TRỮ CAMERA</div>
      <Row>
        <Col span={24}>
          <Table
            size="small"
            columns={column}
            pagination={{
              total: storageCamera?.length || 0,
              position: ['bottomRight'],
              pageSizeOptions: [10, 20, 50, 100, 200, 400],
            }}
            dataSource={storageCamera}
          />
        </Col>
      </Row>
    </div>
  );
};

export default StorageReportSection;
